import { api } from '..';
import { OrderAndSalesCountResponse, SimpleOrderEntity } from '../../types';
import {
  GetAllOrdersBrandOwnerParams,
  GetAllOrdersCountAndSalesBrandOwner,
} from '../../types/brandOwner';
import { ResponseType } from '../../types/shared.types';

export const getBrandOwnerOrders = (params: GetAllOrdersBrandOwnerParams) =>
  api.get<ResponseType<SimpleOrderEntity[]>>(`/v2/orders/brand-owner`, {
    params,
  });

export const getAllOrderCountAndSalesBrandOwner = (
  params: GetAllOrdersCountAndSalesBrandOwner
) =>
  api.get<ResponseType<Array<OrderAndSalesCountResponse>>>(
    `/v2/orders/brand-owner/sales-per-day-subtotal`,
    { params }
  );
